"use client";

/* eslint-disable @next/next/no-img-element */
import { useEffect, useState, type ImgHTMLAttributes } from "react";
import { afterInitialPaintOrInteraction } from "@/lib/after-initial-paint";

const PIXEL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

/** Native lazy loading can fetch several screens ahead before the LCP photo. */
export function DeferredListImage({ src, srcSet, alt, ...props }: ImgHTMLAttributes<HTMLImageElement>) {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    let mounted = true;
    afterInitialPaintOrInteraction(() => { if (mounted) setReady(true); });
    return () => { mounted = false; };
  }, []);
  return (
    <>
      <img {...props} alt={alt} src={ready ? src : PIXEL} srcSet={ready ? srcSet : undefined} data-deferred-photo={ready ? undefined : ""} />
      <noscript>
        <style>{"img[data-deferred-photo]{display:none}"}</style>
        <img {...props} alt={alt} src={src} srcSet={srcSet} />
      </noscript>
    </>
  );
}
